import { client } from './client'
import type {
  Agent,
  AgentDetail,
  AgentVersion,
  AgentMemoryEntry,
  CreateAgentRequest,
  CreateAgentResponse,
  UpdateAgentRequest,
  CreateAgentVersionRequest,
  CreateAgentVersionResponse,
  CreateAgentMemoryEntryRequest,
  CreateAgentMemoryEntryResponse,
  UpdateAgentMemoryEntryRequest,
} from '@/types'

export const agentsApi = {
  getAll: (projectId: string) =>
    client.get<Agent[]>(`/projects/${projectId}/agents`).then(r => r.data),

  getById: (projectId: string, id: string) =>
    client.get<AgentDetail>(`/projects/${projectId}/agents/${id}`).then(r => r.data),

  create: (projectId: string, data: CreateAgentRequest) =>
    client.post<CreateAgentResponse>(`/projects/${projectId}/agents`, data).then(r => r.data),

  update: (projectId: string, id: string, data: UpdateAgentRequest) =>
    client.put<void>(`/projects/${projectId}/agents/${id}`, data).then(r => r.data),

  delete: (projectId: string, id: string) =>
    client.delete(`/projects/${projectId}/agents/${id}`).then(r => r.data),

  duplicate: (projectId: string, id: string) => 
    client.post(`/projects/${projectId}/agents/${id}/duplicate`).then(r => r.data),

  createVersion: (projectId: string, id: string, data: CreateAgentVersionRequest) =>
    client.post<CreateAgentVersionResponse>(`/projects/${projectId}/agents/${id}/versions`, data).then(r => r.data),

  getVersions: (projectId: string, id: string) =>
    client.get<AgentVersion[]>(`/projects/${projectId}/agents/${id}/versions`).then(r => r.data),

  getMemory: (projectId: string, id: string) =>
    client.get<AgentMemoryEntry[]>(`/projects/${projectId}/agents/${id}/memory`).then(r => r.data),

  createMemoryEntry: (projectId: string, id: string, data: CreateAgentMemoryEntryRequest) =>
    client.post<CreateAgentMemoryEntryResponse>(`/projects/${projectId}/agents/${id}/memory/entries`, data).then(r => r.data),

  updateMemoryEntry: (projectId: string, id: string, entryId: string, data: UpdateAgentMemoryEntryRequest) =>
    client.put<void>(`/projects/${projectId}/agents/${id}/memory/entries/${entryId}`, data).then(r => r.data),

  deleteMemoryEntry: (projectId: string, id: string, entryId: string) =>
    client.delete<void>(`/projects/${projectId}/agents/${id}/memory/entries/${entryId}`).then(r => r.data),
}
